module.exports = __webpack_public_path__ + "static/media/codeTurtleRace.c40e967b.jpg";